import angular from 'angular';
import { postImageComponent } from './postImageComponent';

import 'components/sharpr/image/sizer/imageSizerModule';
import 'components/sharpr/theme/themeModule';
import 'components/sharpr/api/apiModule';
import 'components/sharpr/modal/modalModule';
import 'components/sharpr/eventTracker/eventTrackerModule';

angular
	.module('sh.postImage', ['sh.imageSizer', 'sh.theme', 'sh.api', 'sh.modal', 'sh.eventTracker'])
	.component('shPostImage', postImageComponent());
